<template>
    <v-card v-if="order.customs_declaration || 1">
        <v-card-title class="headline">
            View/Edit Customs Declaration - {{ order.name }}
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" x-small icon @click="$emit('close')"><v-icon color="grey">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>{{customs_declaration}} </v-card-text>

        <v-card-text>
            <v-row no-gutters>
                <v-col cols="3">
                    <span class="font-weight-bold">Description of Goods</span>
                </v-col>
                <v-col cols="1">
                    <span class="font-weight-bold">Qty</span>
                </v-col>
                <v-col cols="1">
                    <span class="font-weight-bold">Weight</span>
                </v-col>
                <v-col cols="2">
                    <span class="font-weight-bold">Value</span>
                </v-col>
                <v-col cols="2">
                    <span class="font-weight-bold">HS Code</span>
                </v-col>
                <v-col cols="2">
                    <span class="font-weight-bold">Origin</span>
                </v-col>
            </v-row>    

            <v-row v-for="(item, index) of customs_declaration.line_items" v-bind:key="index" no-gutters class="pb-1">
                <v-col cols="3" class="pr-1">
                    <v-text-field dense outlined hide-details v-model="item.description" class="caption text-right"></v-text-field>
                </v-col>
                <v-col cols="1" class="pr-1">
                    <v-text-field dense outlined hide-details v-model.number="item.quantity" class="caption text-right"></v-text-field>
                </v-col>
                <v-col cols="1" class="pr-1">
                    <v-text-field dense outlined hide-details v-model.number="item.weight" class="caption text-right"></v-text-field>
                </v-col>
                <v-col cols="2" class="pr-1">
                    <v-text-field dense outlined hide-details v-model.number="item.value" class="caption text-right"></v-text-field>
                </v-col>
                <v-col cols="2" class="pr-1">
                    <v-text-field dense outlined hide-details v-model="item.tariff_code" class="caption text-right"></v-text-field>
                </v-col>
                <v-col cols="1" class="pr-1">
                    <v-text-field dense outlined hide-details v-model="item.country_of_origin" class="caption text-right"></v-text-field>
                </v-col>
                <v-col cols="1" class="pt-2">
                    <v-icon color="red" @click="customs_declaration.line_items.splice(index, 1)">
                        mdi-delete-forever-outline
                    </v-icon>
                </v-col>
            </v-row>    
        </v-card-text>
        <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn size="large" @click.native="cancel">Cancel</v-btn>
            <v-btn size="large" @click.native="reset">Reset</v-btn>
            <v-btn color="primary" size="large" @click.native="agree">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import Vue from 'vue'
import mergeTools from "@/V2/helpers/mergeTools";
import orderTools from "@/V2/helpers/orderTools";
import { mapGetters } from 'vuex'
import { countries } from '@/V2/helpers/countries'

export default {
    props: ['order', 'edit'],
    data: () => ({
        merged: mergeTools,
        countries: countries,
        customs_declaration: {}
    }),
    watch: {
        edit: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
                if(newVal) {
                    this.init()
                }
            }
        }
    },
    methods: {
        open(order) {
            return new Promise((resolve, reject) => {
            this.resolve = resolve
            this.reject = reject
            })
        },
        agree() {
            // save the customs dec?? maybe don't need to do anything here except lock it in
            console.log('saving customs', this.order)
            Vue.set(this.order, 'customs_declaration', this.customs_declaration)
            console.log('order', this.order)
            this.$store.dispatch('Orders/save', this.order)
            this.$emit("close")
        },
        reset() {
            console.log('cancel customs dec', this.order.customs_declaration)
            Vue.delete(this.order, 'customs_declaration')
            this.$store.dispatch('Orders/save', this.order)
            this.init()
        },
        cancel() {
            this.$emit("close")
        },
        init: async function () {
            console.log('init customs dec', this.order.customs_declaration)
            if(!this.order.customs_declaration) {
                console.log('building new customs dec')
                const line_items = await orderTools.build_customs_declaration(this.order)
                this.customs_declaration = {line_items: line_items}
                // build a customs dec
            } else {
                console.log('using existing customs dec')
                this.customs_declaration = this.order.customs_declaration
            }
        }
    },
    mounted: function () {
        this.init()
    },
	computed : {
        ...mapGetters({
            display_settings: 'Settings/display_settings',
            images: 'Images/images',

        }),
        sorted_countries () {
            const sortedCountries = this.countries.slice().sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
                return 0;
            });
            return sortedCountries
        }
    }
}
</script>

<style scoped>
::v-deep(.coo-placeholder input::placeholder) {
  color: #ff0000; /* Example: indigo */
}
</style>